export default __webpack_public_path__ + "static/media/up-arrow.fcb3bdaa.svg";